import React from "react";
import styled from "styled-components";
import { Narrow as EdenLightRays } from "@churchofjesuschrist/eden-light-rays";
const LightRaysStyled = styled(EdenLightRays).withConfig({
  componentId: "sc-wefyha-0"
})(["position:absolute;left:0;right:0;bottom:-1px;"]);

const LightRays = () => /*#__PURE__*/React.createElement(LightRaysStyled, {
  color: "#fff",
  origin: "bottom"
});

export default LightRays;